import { coreApi } from '@cp/shared/api/core';
import { ApiTags } from '@cp/shared/api/core/const';
import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ApiRouteBody } from '@common/api/routeBody';
import { ClientBillingPaymentCardCreateResponse } from '@common/model/client/billing/paymentCardCreateResponse';
import { ApiRoutePathParams } from '@common/api/routePathParams';
import { ClientPaymentCardViewModel } from '@common/model/client/billing/paymentCardView';
import { ClientSubscriptionViewModel } from '@common/model/billing/clientSubscription/view';
import { ClientSubscriptionProcessingResult } from '@common/model/billing/clientSubscription';
import { PromocodeApiTags } from '../../../../promocode';

export const clientBillingApi = coreApi
  .enhanceEndpoints({
    addTagTypes: [PromocodeApiTags.PromocodeUsages],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createPaymentCard: builder.mutation<
        // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
        ClientBillingPaymentCardCreateResponse | ClientSubscriptionProcessingResult,
        ApiRouteBody[ApiRoute.ClientBillingPaymentCardsCreate]
      >({
        query: (body) => ({
          url: generateApiUrl(ApiRoute.ClientBillingPaymentCardsCreate),
          method: apiRouteMethodDict[ApiRoute.ClientBillingPaymentCardsCreate],
          body,
        }),
        invalidatesTags: [ApiTags.ClientPaymentCardList],
      }),

      getPaymentCardList: builder.query<ClientPaymentCardViewModel[], void>({
        query: () => ({
          url: generateApiUrl(ApiRoute.ClientBillingPaymentCardsGet),
          method: apiRouteMethodDict[ApiRoute.ClientBillingPaymentCardsGet],
        }),
        providesTags: [ApiTags.ClientPaymentCardList],
      }),

      deletePaymentCard: builder.mutation<void, ApiRoutePathParams[ApiRoute.ClientBillingPaymentCardsDelete]>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientBillingPaymentCardsDelete, params),
          method: apiRouteMethodDict[ApiRoute.ClientBillingPaymentCardsDelete],
        }),
        invalidatesTags: [ApiTags.ClientPaymentCardList],
      }),

      startBillingSubscription: builder.mutation<ClientSubscriptionProcessingResult, ApiRouteBody[ApiRoute.ClientBillingSubscriptionStart]>(
        {
          query: (body) => ({
            url: generateApiUrl(ApiRoute.ClientBillingSubscriptionStart),
            method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionStart],
            body,
          }),
          invalidatesTags: [ApiTags.ClientBillingSubscription, PromocodeApiTags.PromocodeUsages],
        },
      ),

      getBillingSubscription: builder.query<ClientSubscriptionViewModel, void>({
        query: () => ({
          url: generateApiUrl(ApiRoute.ClientBillingSubscriptionGet),
          method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionGet],
        }),
        providesTags: [ApiTags.ClientBillingSubscription],
      }),

      stopBillingSubscription: builder.mutation<void, void>({
        query: () => ({
          url: generateApiUrl(ApiRoute.ClientBillingSubscriptionStop),
          method: apiRouteMethodDict[ApiRoute.ClientBillingSubscriptionStop],
        }),
        invalidatesTags: [ApiTags.ClientBillingSubscription],
      }),
    }),
  });
